import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeContainer from '@/modules/HomeContainer'
import Erro404 from '@/modules/Erro404'
import SystemMenuContainer from '@/modules/SystemMenuContainer'

/* SECURITY-DS */
import Signin from '@/modules/security_ds/v01/authentication/Signin'
import SecurityCredentialContainer from '@/modules/security_ds/internal/SecurityCredentialContainer'
import SecurityProviderContainer from '@/modules/security_ds/internal/SecurityProviderContainer'
import SecurityRoleContainer from '@/modules/security_ds/internal/SecurityRoleContainer'
/* STREAMLINE-DS */
import SchedulerContainer from '@/modules/streamline_ds/internal/SchedulerContainer'
import QueueContainer from '@/modules/streamline_ds/internal/QueueContainer'
import ServiceDocContainer from '@/modules/streamline_ds/internal/ServiceDocContainer'
import ServiceDocSearchContainer from '@/modules/streamline_ds/internal/ServiceDocSearchContainer'
import ResourceContainer from '@/modules/streamline_ds/internal/ResourceContainer'
/*CHAMELEON-DS */
import BpmProcessContainer from '@/modules/chameleon_ds/internal/BpmProcessContainer'
import BpmHomeContainer from '@/modules/chameleon_ds/internal/BpmHomeContainer'
/* SUPPORT-TICKET-DS */
import SupportTicketContainer from '@/modules/support_ticket_ds/internal/SupportTicketContainer'
/* NOTIFICATIONS-DS */
import NotificationsContainer from '@/modules/notifications_ds/internal/NotificationsContainer'
import ConfigurationsContainer from '@/modules/notifications_ds/internal/ConfigurationsContainer'
import MessagesContainer from '@/modules/notifications_ds/internal/MessagesContainer'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter)
const routes = [
    {
        name: 'system-menu',
        path: '/modules/system_menu_container',
        component: SystemMenuContainer,
        meta: { layout: 2 },
    },
    {
        name: 'home',
        path: '/modules/home_container',
        component: HomeContainer,
        meta: { layout: 2 },
    },
    {
        name: 'signin',
        path: '/signin',
        component: Signin,
        meta: { layout: 1 },
    },
    {
        name: 'security-credential',
        path: '/modules/security_ds/internal/security_credential_container',
        component: SecurityCredentialContainer,
        meta: { layout: 2 },
    },
    {
        name: 'security-provider',
        path: '/modules/security_ds/internal/security_provider_container',
        component: SecurityProviderContainer,
        meta: { layout: 2 },
    },
    {
        name: 'security-role',
        path: '/modules/security_ds/internal/security_role_container',
        component: SecurityRoleContainer,
        meta: { layout: 2 },
    },
    {
        name: 'scheduler',
        path: '/modules/streamline_ds/internal/scheduler_container',
        component: SchedulerContainer,
        meta: { layout: 2 },
    },
    {
        name: 'queue',
        path: '/modules/streamline_ds/internal/queue_container',
        component: QueueContainer,
        meta: { layout: 2 },
    },
    {
        name: 'service-doc',
        path: '/modules/streamline_ds/internal/service_doc_container',
        component: ServiceDocContainer,
        meta: { layout: 2 },
    },
    {
        name: 'service-doc-search',
        path: '/modules/streamline_ds/internal/service_doc_search_container',
        component: ServiceDocSearchContainer,
        meta: { layout: 2 },
    },
    {
        name: 'resource',
        path: '/modules/streamline_ds/internal/resource_container',
        component: ResourceContainer,
        meta: { layout: 2 },
    },
    {
        name: 'support-ticket',
        path: '/modules/support_ticket_ds/internal/support_ticket_container',
        component: SupportTicketContainer,
        meta: { layout: 2 },
    },
    {
        name: 'bpm_process',
        path: '/modules/chameleon_ds/internal/bpm_process_container',
        component: BpmProcessContainer,
        meta: { layout: 2 },
    },
    {
        name: 'bpm_home',
        path: '/modules/chameleon_ds/internal/bpm_home_container',
        component: BpmHomeContainer,
        meta: { layout: 2 },
    },
    {
        name: 'notifications',
        path: '/modules/notifications_ds/internal/notifications_container',
        component: NotificationsContainer,
        meta: { layout: 2 },
    },
    {
        name: 'configurations',
        path: '/modules/notifications_ds/internal/configurations_container',
        component: ConfigurationsContainer,
        meta: { layout: 2 },
    },
    {
        name: 'messages',
        path: '/modules/notifications_ds/internal/messages_container',
        component: MessagesContainer,
        meta: { layout: 2 },
    },
    {
        name: 'modelo',
        path: '/modules/modelo/modelo_container',
        component: Signin,
        meta: { layout: 2 },
    },
    {
        name: 'erro404',
        path: '/erro404',
        component: Erro404,
        meta: { layout: 1 },
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
